import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { FC } from 'react';
import noOffersStop from 'assets/img/icons/no-offers-stop.svg';
import { Color } from 'presentation/theme/colorScheme';

interface Props {
  orderBook: PeAssetOrderBook;
}

const PeOffersGridItemOrderBook: FC<Props> = ({ orderBook }) => {
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  const total = (orderBook.buy?.count ?? 0) + (orderBook.sell?.count ?? 0);
  const buyRatio = orderBook.buy ? orderBook.buy.count / total : 0;
  const sellRatio = orderBook.sell ? orderBook.sell.count / total : 0;

  const noOffersIcon = <Image src={noOffersStop} w="14px" h="14px" />;

  return (
    <Box>
      <Flex alignItems="center" justifyContent="space-between" mb="8px">
        {orderBook.buy ? (
          <Text fontSize="18px">{orderBook.buy.price}</Text>
        ) : (
          noOffersIcon
        )}
        <Box w="5px" />
        {orderBook.sell ? (
          <Text fontSize="18px">{orderBook.sell.price}</Text>
        ) : (
          noOffersIcon
        )}
      </Flex>
      <Flex justifyContent="space-between">
        <Box
          borderRadius="6px"
          bgColor={Color.Profit}
          minW={orderBook.buy ? '4px' : 0}
          h="7px"
          flex={buyRatio}
        />
        {orderBook.buy && orderBook.sell && <Box w="8px" />}
        <Box
          borderRadius="6px"
          bgColor={Color.Loss}
          h="7px"
          minW={orderBook.sell ? '4px' : 0}
          flex={sellRatio}
        />
      </Flex>
    </Box>
  );
};

export default PeOffersGridItemOrderBook;
